import { render } from "./stories.vue?vue&type=template&id=5d26e731&bindings={\"navigate\":\"props\"}"
import script from "./stories.vue?vue&type=script&lang=js"
export * from "./stories.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./stories.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script